import { render, staticRenderFns } from "./DataStatistics.vue?vue&type=template&id=ae4bfbce&scoped=true"
import script from "./DataStatistics.vue?vue&type=script&lang=js"
export * from "./DataStatistics.vue?vue&type=script&lang=js"
import style0 from "./DataStatistics.vue?vue&type=style&index=0&id=ae4bfbce&prod&lang=scss"
import style1 from "./DataStatistics.vue?vue&type=style&index=1&id=ae4bfbce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae4bfbce",
  null
  
)

export default component.exports